import { TId } from '@/features/common';

export enum EAutomationType {
  /** When a candidate applies, send them an email \<template\> */
  SentEmailToAppliedCandidate = 'sent_email_to_applied_candidate',

  /** When a candidate applies, move them to stage \<stage\> */
  MoveAppliedCandidate = 'move_applied_candidate',

  /** When a candidate is moved to this stage, send them an email \<template\> */
  SendEmailToMovedCandidate = 'send_email_to_moved_candidate',

  /** When a candidate is moved to this stage, invite them to the test \<template\> */
  SendTestInviteToMovedCandidate = 'send_test_invite_to_moved_candidate',

  /** When a candidate scores more than \<score\> %, move them to stage \<stage\> */
  MoveOverThresholdCandidate = 'move_over_threshold_candidate',

  /** When a candidate scores less than \<score\> %, move them to stage \<stage\> */
  MoveUnderThresholdCandidate = 'move_under_threshold_candidate',

  /** When a candidate scores less than \<score\> %, mark them as rejected and send them a rejection email \<template\> */
  SendRejectionToUnderThresholdCandidate = 'send_rejection_to_under_threshold_candidate',

  /** When a candidate scores less than \<score\> %, mark them as rejected */
  RejectUnderThresholdCandidate = 'reject_under_threshold_candidate',

  /** Remind candidates to take the test after \<days\> days */
  SendTestReminder = 'send_test_reminder',

  /** When a candidate is moved to this stage, invite them to the interview \<template\> */
  // SendInterviewInviteToMovedCandidate = 'send_interview_invite_to_moved_candidate',
}

export interface IAutomation {
  id: TId;
  stageId: TId;
  type: EAutomationType;
  enabled: boolean;
  authorId?: TId;
  createdAt: Date;
  destinationStageId: TId | null;
  templateId: TId | null;
  systemTemplateId: TId | null;
  value: number | null;
}
